<script setup lang="ts">
import gpsModule from '@/shared/Containment/modules/gps';

const { $containment } = useNuxtApp();

type Props = {
  hideButton?: boolean;
  buttonLabel?: string;
};

const { hideButton = false } = defineProps<Props>();

type Emits = {
  onLoading: [boolean];
  onSuccess: [];
  onError: [];
};

const emit = defineEmits<Emits>();

async function onVerifyGeolocationButtonClick() {
  emit('onLoading', true);

  const isValid = await gpsModule();

  if (isValid) {
    await $containment.solve({ name: 'gps' });
    emit('onSuccess');
  } else {
    emit('onError');
  }

  emit('onLoading', false);
}
</script>

<template>
  <button
    :class="[
      $style.geolocationButtton,
      'btn-primary',
      { [$style.hideButton]: hideButton },
    ]"
    @click="onVerifyGeolocationButtonClick"
  >
    {{ buttonLabel ? buttonLabel : $t('verification.gps.allow_location') }}
    <NuxtIcon name="arrows/angle_right" />
  </button>
</template>

<style module lang="scss">
.geolocationButtton {
  @apply rounded-md gap-1.5 flex items-center font-bold uppercase py-2.5 focus:outline-none focus:ring-4;

  &.hideButton {
    @apply max-h-0 overflow-hidden p-0 invisible absolute;
  }
}
</style>
